export function applyRestaurantCustoms() {
  const root = document.documentElement;

  const primary = sessionStorage.getItem('restaurant_primary_color') || '#F47700';
  const secondary = sessionStorage.getItem('restaurant_secondary_color') || null;

  root.style.setProperty('--primary-color', primary);
  root.style.setProperty('--secondary-color', secondary);

  const rgbPrimary = hexToRgb(primary);
  root.style.setProperty('--primary-color-rgb', rgbPrimary);
}

export async function initAndApplyRestaurantCustoms(token = null, restaurant_id = null) {
  console.log("es aqui?")
  try {
    let customization = null;
    if (restaurant_id === null) {
      const response = await fetch(`${process.env.VUE_APP_API_URL}/v1/api/app/me_table`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      customization = data.restaurant?.customization;
    }else{
      const response = await fetch(`${process.env.VUE_APP_API_URL}/v1/api/app/restaurant_customization?restaurant_id=${restaurant_id}`, {});
      customization = await response.json();
    }    

    if (customization) {
      if (customization.primary_color)
        sessionStorage.setItem('restaurant_primary_color', customization.primary_color);
      if (customization.secondary_color)
        sessionStorage.setItem('restaurant_secondary_color', customization.secondary_color);
    }
  } catch (e) {
    console.warn("Error al cargar personalización del restaurante:", e);
  }

  applyRestaurantCustoms();
}

function hexToRgb(hex) {
  const cleanHex = hex?.replace('#', '') || 'f47700';
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
}